// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2C8j0","actionsCol":"EnrolledClinics_actionsCol__1FGVX"};